module.exports = __webpack_public_path__ + "img/dashboard.917d9881.jpg";